export const extractLayoutProps = (
  {
    assemblies,
    heroContent,
    createdAt,
    updatedAt,
    lastAmended,
    title,
    internal: { type } = {},
    navigation,
    pageInformation,
    contentful_id: pageContentfulId,
  },
  { mainNavigation = {} }
) => ({
  assemblies,
  heroContent,
  createdAt,
  updatedAt,
  lastAmended,
  title,
  type,
  mainNavigation,
  path: navigation?.path,
  canonicalTag: pageInformation?.canonicalTag,
  pageContentfulId,
});
